const SPECIAL_CHAR_REGEX = /[!@#/$%&*]/;

export type PasswordCriteriaStatus = {
  hasMinLength: boolean;
  hasSpecialChar: boolean;
  hasNoSequenceOrRepetition: boolean;
};

function hasSequentialChars(password: string): boolean {
  if (password.length < 4) return false;

  const normalized = password.toLowerCase();

  for (let i = 0; i <= normalized.length - 4; i++) {
    let ascending = true;
    let descending = true;

    for (let j = 0; j < 3; j++) {
      const current = normalized.charCodeAt(i + j);
      const next = normalized.charCodeAt(i + j + 1);

      if (next !== current + 1) ascending = false;
      if (next !== current - 1) descending = false;
    }

    if (ascending || descending) return true;
  }

  return false;
}

function hasRepeatedChars(password: string): boolean {
  if (password.length < 4) return false;

  const normalized = password.toLowerCase();

  for (let i = 0; i <= password.length - 4; i++) {
    const chunk = normalized.slice(i, i + 4);
    if (chunk.split('').every(char => char === chunk[0])) return true;
  }

  return false;
}

export function getPasswordCriteriaStatus(
  password: string
): PasswordCriteriaStatus {
  return {
    hasMinLength: Boolean(password && password.length >= 8),
    hasSpecialChar: SPECIAL_CHAR_REGEX.test(password),
    hasNoSequenceOrRepetition:
      !hasSequentialChars(password) && !hasRepeatedChars(password)
  };
}

export function isPasswordValid(password: string): boolean {
  const c = getPasswordCriteriaStatus(password);
  return c.hasMinLength && c.hasSpecialChar && c.hasNoSequenceOrRepetition;
}
